{
  "Sidebar": {
    "badges": {
      "beta": "Bêta"
    },
    "guest": {
      "title": "Enregistrez votre travail",
      "description": "Inscrivez-vous gratuitement pour sauvegarder définitivement vos examens, discussions et paramètres.",
      "loginButton": "Se connecter maintenant"
    },
    "actions": {
      "newExamTitle": "Créer un nouvel examen",
      "creating": "Création en cours...",
      "newExam": "Nouvel examen"
    },
    "examList": {
      "title": "Mes examens",
      "noExams": "Aucun examen trouvé.",
      "unnamed": "Sans titre",
      "unnamedExam": "Examen sans titre",
      "loadOlder": "Charger les examens plus anciens"
    },
    "examMenu": {
      "edit": "Modifier",
      "addToClass": "Ajouter à la classe",
      "delete": "Supprimer"
    },
    "bottomNav": {
      "profile": "Profil",
      "settings": "Paramètres",
      "feedback": "Donner un avis"
    },
    "dialogs": {
      "renameTitle": "Modifier l'examen",
      "groupTitle": "Grouper l'examen",
      "renameDesc": "Modifiez les informations de cet examen.",
      "groupDesc": "Sélectionnez une classe ou un groupe pour cet examen.",
      "fields": {
        "name": "Nom",
        "subject": "Matière",
        "topic": "Sujet",
        "class": "Classe",
        "placeholderSelect": "Veuillez sélectionner..."
      },
      "save": "Enregistrer"
    },
    "alerts": {
      "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet examen ?",
      "saveFailed": "Échec de l'enregistrement"
    }
  },
  "Settings": {
    "title": "Paramètres",
    "soon": "Prochainement",
    "DisplayAndLanguage": {
      "title": "Affichage & Langue",
      "languageLabel": "Langue",
      "languageDesc": "Choisissez la langue de l'interface.",
      "themeLabel": "Apparence",
      "themeDesc": "Basculez entre le mode clair et sombre."
    },
    "AI": {
      "title": "IA et Notation",
      "strictnessLabel": "Incertitude de l'IA",
      "strictnessDesc": "Détermine à quel niveau de confiance de l'IA une révision manuelle est obligatoire.",
      "strictnessWarning": "Avertissement : Avec une \"Haute Autonomie\", vous n'intervenez manuellement que lorsque l'IA est très incertaine...",
      "gradingKindnessLabel": "Rigueur de la Notation",
      "gradingKindnessDesc": "Détermine avec quelle rigueur l'IA applique le barème de notation. Indulgent favorise l'étudiant dans les cas limites ; Strict suit le barème à la lettre.",
      "gradingKindnessOptions": {
        "lenient": "Indulgent",
        "balanced": "Équilibré",
        "strict": "Strict"
      }
    },
    "Notifications": {
      "title": "Notifications",
      "soon": "Prochainement",
      "emailLabel": "Notifications par e-mail",
      "emailDesc": "Recevez des notifications par e-mail concernant les événements importants.",
      "browserLabel": "Notifications du navigateur",
      "browserDesc": "Recevez des notifications push directement dans votre navigateur."
    },
    "About": {
      "title": "À propos de Gradias",
      "landingPage": "Visiter gradias.ai",
      "support": "Aide & Support",
      "imprint": "Mentions légales",
      "privacy": "Politique de confidentialité"
    },
    "Account": {
      "title": "Données & Compte",
      "exportLabel": "Exporter mes données",
      "exportDesc": "Téléchargez tous les examens téléchargés et les résultats dans un fichier ZIP.",
      "deleteLabel": "Supprimer mon compte",
      "deleteDesc": "Supprimez définitivement votre compte et toutes les données associées."
    }
  },
  "Profile": {
    "title": "Profil",
    "actions": {
      "cancel": "Annuler",
      "save": "Enregistrer",
      "edit": "Modifier"
    },
    "alerts": {
      "saveError": "Le profil n'a pas pu être enregistré.",
      "generalError": "Une erreur s'est produite."
    },
    "personal": {
      "firstName": "Prénom",
      "lastName": "Nom de famille",
      "name": "Nom",
      "school": "École",
      "noSchool": "Aucune école indiquée",
      "email": "E-mail",
      "emailHint": "L'adresse e-mail ne peut pas être modifiée ici.",
      "defaultUser": "Utilisateur",
      "role": {
        "teacher": "Enseignant(e)",
        "student": "Élève"
      }
    },
    "teaching": {
      "subjects": "Mes matières"
    },
    "rules": {
      "title": "Règles et préférences",
      "description": "Préférences enregistrées que l'assistant respecte — lors des échanges, de la notation et de la création de corrigés types et de barèmes. Vous pouvez les modifier ici vous-même, mais l'assistant peut aussi les ajuster pour vous directement dans le chat.",
      "general": "Général",
      "empty": "Aucune règle enregistrée pour l'instant.",
      "addRule": "Ajouter une règle",
      "removeRule": "Supprimer la règle",
      "limitReached": "Limite atteinte",
      "limitHint": "Jusqu'à {{max}} règles par catégorie",
      "placeholder": "Décrivez une règle …",
      "categories": {
        "chat_and_workflow": "Chat et déroulement",
        "grading_and_feedback": "Notation et retours",
        "master_solution_design": "Corrigés types",
        "grading_scheme_creation": "Barèmes"
      },
      "categoryDescs": {
        "chat_and_workflow": "Comment l'assistant répond dans le chat et gère le déroulement",
        "grading_and_feedback": "Comment les réponses sont notées et les retours rédigés",
        "master_solution_design": "Comment les corrigés types sont créés",
        "grading_scheme_creation": "Comment les barèmes sont construits"
      },
      "grammar": {
        "alwaysUseFi": "Toujours utiliser l'indice d'erreurs (FI)",
        "alwaysUseFiDesc": "Utilise par défaut l'indice d'erreurs au lieu de toute règle de grammaire détectée dans un barème téléversé. Peut être remplacé par examen.",
        "languageUseRegradeWordCutoff": "Réévaluer automatiquement la maîtrise de la langue à partir de (mots)",
        "languageUseRegradeWordCutoffDesc": "Lors de la modification de la réponse d'un élève, la maîtrise de la langue du groupe concerné est automatiquement réévaluée dès que ce nombre de mots au moins a été modifié (plusieurs petites modifications s'additionnent).",
        "contentRegradeWordCutoff": "Réévaluer automatiquement le contenu à partir de (mots)",
        "contentRegradeWordCutoffDesc": "0 = toujours (par défaut) : le contenu est réévalué immédiatement à chaque modification de texte. Une valeur plus élevée ignore la réévaluation automatique pour de très petites modifications."
      }
    },
    "security": {
      "title": "Compte & Sécurité",
      "changePassword": "Changer le mot de passe",
      "changePasswordDesc": "Gérez la sécurité de votre compte",
      "logout": "Se déconnecter",
      "logoutDesc": "Déconnectez-vous en toute sécurité de cet appareil"
    },
    "badges": {
      "soon": "Prochainement"
    }
  },
  "ClassInsights": {
    "overview": "Aperçu",
    "examCount": "Examens",
    "subjectCount": "Matières",
    "gradedCount": "Corrigés",
    "examListTitle": "Examens de cette classe",
    "noExams": "Aucun examen dans cette classe pour le moment.",
    "loading": "Chargement des statistiques …",
    "statusGraded": "Corrigé",
    "statusInProgress": "En cours",
    "unnamedExam": "Examen sans titre",
    "unknownSubject": "Matière inconnue"
  },
  "Dashboard": {
    "guestMessage": "Je suis gradi, votre assistant IA de correction d'examens.",
    "greetings": {
      "opt1": "Quels examens corrigeons-nous aujourd'hui ?",
      "opt2": "Attaquons-nous à votre pile d'examens.",
      "opt3": "Quel est le programme aujourd'hui ?",
      "opt4": "Comment puis-je vous aider aujourd'hui ?",
      "opt5": "Ravi de vous voir. Par où commençons-nous ?",
      "opt6": "C'est parti pour la correction !"
    },
    "fallbackGreeting": "Quel est le programme aujourd'hui ?",
    "greetingPrefix": "Bonjour",
    "inputPlaceholder": "Posez une question...",
    "dropzoneText": "Déposez les fichiers ici",
    "actions": {
      "startGrading": {
        "label": "Démarrer la correction d'examen",
        "prompt": "Je souhaite démarrer la correction d'un nouvel examen. Veuillez me guider étape par étape, du téléchargement au barème de notation."
      },
      "howItWorks": {
        "label": "Comment fonctionne gradias ?",
        "prompt": "Expliquez-moi brièvement comment fonctionne gradias et quelles étapes je dois suivre pour une correction réussie."
      },
      "sampleData": {
        "label": "Tester avec des exemples de données",
        "prompt": "Je veux tester le système mais je n'ai pas mes propres examens sous la main. Comment puis-je faire un test avec un exemple d'examen ?"
      },
      "taskTypes": {
        "label": "Quels sont les types de tâches ?",
        "prompt": "Quels types de tâches (par ex. texte libre, choix multiple, équations mathématiques) pouvez-vous corriger actuellement ?"
      },
      "privacy": {
        "label": "Confidentialité et sécurité des données",
        "prompt": "Comment gradias gère-t-il la confidentialité des données ? Que se passe-t-il avec les examens téléchargés de mes élèves ?"
      }
    },
    "alerts": {
      "uploadError": "Erreur lors du téléchargement du fichier",
      "noExamId": "Aucun examId présent"
    },
    "aria": {
      "uploadFiles": "Télécharger des fichiers",
      "submit": "Soumettre",
      "removeFile": "Supprimer le fichier joint"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "Toutes les étapes sont terminées",
      "configRunning": "Terminé - Prêt pour la suite",
      "readyForConfig": "Prêt pour la configuration",
      "status": "Statut",
      "progress": "Progression",
      "inProgress": "en cours"
    },
    "steps": {
      "examCreator": {
        "label": "Créer l'examen",
        "phasePlan": "Planification de l'examen",
        "phaseMaterial": "Génération des figures",
        "phaseSource": "Rédaction des exercices",
        "phaseRepair": "Finalisation du document"
      },
      "upload": {
        "label": "Téléchargement de fichiers"
      },
      "studentAssignment": {
        "label": "Attribution des élèves",
        "activeWait": "En attente de confirmation",
        "activeAssign": "Attribuer les copies des élèves"
      },
      "structure": {
        "label": "Structure de l'examen",
        "active": "Détection des tâches"
      },
      "answers": {
        "label": "Réponses des élèves",
        "active": "Traitement des réponses"
      },
      "masterSolution": {
        "label": "Solution type",
        "activeDetect": "Détection de la solution type",
        "activeCreate": "Création de la solution type",
        "activeComplete": "Complément de la solution type"
      },
      "gradingScheme": {
        "label": "Barème de notation",
        "activeDetect": "Détection des critères de notation",
        "activeCreate": "Création des critères de notation",
        "activeComplete": "Complément des critères d’évaluation"
      },
      "grading": {
        "label": "Correction",
        "active": "Correction en cours"
      },
      "summary": {
        "label": "Aperçu des résultats"
      }
    },
    "badges": {
      "uncertainties": "Incertitudes",
      "errorRegions": "Zones d'erreur",
      "errorSubmissions": "Copies avec erreur",
      "documentEncrypted": "Document chiffré"
    },
    "ui": {
      "showProgress": "Afficher la progression de la correction",
      "dropFilesHere": "Déposez les fichiers ici",
      "uploadFiles": "Télécharger des fichiers",
      "waitUpload": "En attente du téléchargement",
      "sendMessage": "Envoyer le message",
      "privacyNotice": "100% conforme au RGPD. Vos données et les documents des élèves ne sont pas utilisés pour l'entraînement de l'IA.",
      "learnMore": "En savoir plus."
    },
    "alerts": {
      "uploadError": "Erreur lors du téléchargement du fichier",
      "noExamId": "Aucun examId présent"
    }
  },
  "TokenInput": {
    "placeholder": "Posez une question..."
  },
  "Chat": {
    "auth": {
      "login": "Se connecter",
      "register": "S'inscrire"
    },
    "loading": {
      "masterSolutions": "Chargement des solutions types...",
      "examData": "Chargement des données de l'examen & des images...",
      "extractingTasks": "Extraction des tâches... {{finished}}/{{total}}",
      "splitThinkingMessage": "J'affecte les travaux des élèves",
      "structureThinkingMessage": "Je comprends la structure de l'examen",
      "examStructure": "Chargement de la structure de l'examen...",
      "pages": "Chargement des pages...",
      "summary": "Chargement du résumé..."
    },
    "alerts": {
      "errorOccurred": "Désolé, une erreur s'est produite. Veuillez réessayer plus tard.",
      "reportsBlocked": "Les rapports PDF ne sont disponibles que lorsque toutes les tâches principales sont approuvées ou ont une confiance de l'IA supérieure à {{threshold}}%.",
      "noSubmissionsForReports": "Aucune copie avec des données de rapport n'a été trouvée.",
      "reportsFailed": "Impossible de générer les rapports PDF. Veuillez réessayer."
    },
    "sampleExamIntro": "Je souhaite corriger cet examen avec les documents suivants :\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "Ajuster les zones de délimitation",
      "msedit": "Modifier la solution type & le barème",
      "correction": "Correction",
      "summary": "Résumé de la correction",
      "structureeditor": "Modifier la structure de l'examen",
      "submissioncheck": "Vérifier l'attribution des pages",
      "demoselector": "Sélectionner une démo",
      "examcreator": "Créer l'examen",
      "default": "Vue détaillée"
    }
  },
  "Canvas": {
    "common": {
      "resize": "Redimensionner",
      "toSummaryTitle": "Aller au résumé",
      "backToSummary1": "Retour au",
      "backToSummary2": "résumé",
      "restore": "Restaurer",
      "fullscreen": "Plein écran",
      "close": "Fermer"
    },
    "grading": {
      "prevTask": "Tâche précédente",
      "nextTask": "Tâche suivante",
      "taskXofY": "Tâche {{current}} sur {{total}}",
      "taskName": "Tâche {{number}}",
      "nextUncertainty": "Incertitude suivante ({{count}})",
      "uncertaintiesLeft": "{{count}} incertitudes restantes",
      "backToSummary1": "Retour au",
      "backToSummary2": "résumé",
      "submissionX": "Copie {{id}}",
      "pages": "Pages :",
      "pageX": "Page {{page}}",
      "addBoundingBox": "Ajouter une nouvelle zone",
      "extractedText": "Texte extrait",
      "verified": "Vérifié",
      "consistencyAdjusted": "Ajusté automatiquement pour la cohérence avec d'autres copies",
      "bboxConfidence": "Confiance de la zone : {{conf}}%",
      "review": "Réviser",
      "noTextExtracted": "Aucun texte extrait.",
      "imageContent": "Image (sans reconnaissance de texte) - la région d'image reconnue sera utilisée directement pour le traitement ultérieur",
      "aiGrading": "Notation IA",
      "pts": "pts.",
      "points": "Points :",
      "noGradingYet": "Aucune note disponible pour le moment.",
      "gradingScheme": "Barème de notation",
      "expand": "Développer",
      "collapse": "Réduire",
      "maxPoints": "Points max. : {{points}}",
      "noGradingSchemeYet": "Aucun barème disponible pour le moment.",
      "boxModeContent": "Contenu",
      "boxModeLanguageUse": "Maîtrise de la langue",
      "groupLanguageUseRule": "Groupe : tâche {{tasks}}",
      "groupLanguageUseRuleNumbered": "Groupe {{number}} : tâche {{tasks}}",
      "editLanguageUseGroupTasks": "Modifier les tâches de ce groupe",
      "deleteLanguageUseGroup": "Supprimer cette règle de maîtrise de la langue",
      "deleteLanguageUseGroupConfirm": "Supprimer cette règle de maîtrise de la langue ? Cette action est irréversible.",
      "deleteLanguageUseGroupBlocked": "Suppression impossible pendant la notation.",
      "languageUseGroupPickerInfo": "Cochez une tâche pour l'ajouter à ce groupe. Décochez-la pour la retirer ; si elle a encore besoin de sa propre règle de maîtrise de la langue, elle est pré-remplie avec le texte de ce groupe et 0 point afin que vous puissiez la retrouver.",
      "languageUseGroupPickerSaveFailed": "Échec de l'enregistrement. Veuillez réessayer.",
      "languageUseGroupPickerEmptyDraft": "Une règle nécessite au moins une tâche.",
      "deleteBox": "Supprimer la zone",
      "retryOcr": "Relancer la reconnaissance de texte",
      "unlockBox": "Déverrouiller la zone",
      "lockBox": "Verrouiller la zone",
      "noSubmissionsFound": "Aucune copie trouvée.",
      "examPageX": "Page d'examen {{page}}",
      "modeCorrection": "Correction",
      "modeGrammar": "Grammaire",
      "grammarTitle": "Orthographe & Grammaire",
      "grammarErrors": "Erreurs",
      "fehlerindex": "Indice d'erreur",
      "words": "Mots",
      "noGrammarErrors": "Aucune erreur trouvée.",
      "noGrammarEvaluationForTask": "Aucune évaluation grammaticale pour cette tâche.",
      "notLocated": "Non localisé sur l'image",
      "notLocatedShort": "sans marqueur",
      "deleteGrammarError": "Supprimer l'erreur",
      "editGrammarError": "Modifier l'erreur",
      "saveGrammarError": "Enregistrer",
      "addMistake": "Ajouter une erreur",
      "mistakePlaceholder": "Description de l'erreur…",
      "errorCategories": {
        "TYPOS": "Fautes de frappe",
        "GRAMMAR": "Grammaire",
        "SEMANTICS": "Sémantique",
        "STYLE": "Style",
        "PUNCTUATION": "Ponctuation",
        "TYPOGRAPHY": "Typographie",
        "REDUNDANCY": "Redondance",
        "CASING": "Majuscules/Minuscules",
        "COLLOCATIONS": "Collocations",
        "CONFUSED_WORDS": "Confusions de mots",
        "FALSE_FRIENDS": "Faux amis",
        "GENDER_NEUTRALITY": "Neutralité de genre",
        "IDIOMS": "Idiomes",
        "MISC": "Divers",
        "NONSTANDARD_PHRASES": "Expressions non standard",
        "PLAIN_ENGLISH": "Langage simple",
        "PROPER_NOUNS": "Noms propres",
        "REGIONALISMS": "Régionalismes"
      },
      "rerunningOcr": "Nouvelle reconnaissance de texte en cours...",
      "regrading": "Nouvelle notation en cours...",
      "regradingQueued": "En file d'attente..."
    },
    "msgs": {
      "noTasksFound": "Aucune tâche trouvée.",
      "prevTask": "Tâche précédente",
      "nextTask": "Tâche suivante",
      "task": "Tâche",
      "taskMain": "Tâche {{main}}",
      "taskSub": "Tâche {{main}}.{{sub}}",
      "uncertaintiesLeft": "{{count}} incertitudes restantes",
      "nextUncertainty": "Incertitude suivante ({{count}})",
      "taskExcerpt": "Extrait de la tâche",
      "noImageAvailable": "Aucune image disponible...",
      "masterSolution": "Solution type",
      "aiGeneratedProposalTooltip": "Proposition générée par l'IA",
      "aiGeneratedProposal": "Proposition générée par l'IA",
      "review": "Réviser",
      "approvalRequiresPoints": "L'approbation n'est possible que si les points sont supérieurs à 0.",
      "saveRequiresPoints": "L'enregistrement n'est possible que si les points sont supérieurs à 0.",
      "enterMasterSolution": "Entrez la solution type ici...",
      "noMasterSolutionYet": "Aucune solution type disponible pour le moment...",
      "gradingScheme": "Barème de notation",
      "maxPoints": "Points max.",
      "maxPointsValue": "Points max. : {{points}}",
      "enterGradingScheme": "Entrez le barème de notation ici...",
      "noGradingSchemeYet": "Aucun barème disponible pour le moment...",
      "gradingSchemeRefining": "Mise à jour du barème de notation...",
      "masterSolutionRefining": "Mise à jour de la solution type..."
    },
    "submissionCheck": {
      "pageShort": "P. {{page}}",
      "zoomPage": "Zoomer la page {{page}}",
      "pageAlt": "Page",
      "loading": "Chargement...",
      "newStudent": "Nouvel élève",
      "readOnly": "Lecture seule",
      "saveAssignment": "Enregistrer l'attribution",
      "unassignedPagesTitle": "Clarification requise : Pages non attribuées ({{count}})",
      "unassignedPagesHint": "Veuillez glisser ces pages dans les dossiers des élèves.",
      "newStudentIndexed": "Nouvel élève {{index}}",
      "studentIndexed": "Élève {{index}}",
      "enterName": "Saisir un nom...",
      "pageX_one": "{{count}} page",
      "pageX_other": "{{count}} pages",
      "splitConfidenceHover": "Confiance de séparation : {{percent}}%",
      "splitPercent": "Séparation {{percent}}%",
      "deleteStudent": "Supprimer l'élève",
      "dragHint": "Faites glisser les documents ici pour les attribuer à {{name}}",
      "assignmentNotes": "Notes d'attribution",
      "previewPageAlt": "Aperçu de la page {{page}}",
      "pageCurrentOfTotal": "Page {{current}} sur {{total}}",
      "locked": "Confirmé",
      "lockedHint": "Déjà confirmé – ne peut plus être modifié."
    },
    "summary": {
      "studentsOverview": "Résumé des élèves",
      "studentsOverviewDesc": "Points détaillés et évaluation de l'IA par tâche",
      "searchStudent": "Rechercher le nom d'un élève...",
      "student": "Élève",
      "pointsAbbr": "pts.",
      "total": "Total",
      "percentage": "Pourcentage",
      "grade": "Note",
      "noHits": "Aucun résultat.",
      "aiConfidenceHover": "Confiance de l'IA : {{percent}}% - Veuillez vérifier manuellement",
      "aiUncertainties": "Incertitudes de l'IA",
      "aiUncertaintiesDesc": "Passez en revue les cas où l'IA a des doutes pour garantir une notation équitable.",
      "openDecisions": "{{count}} décisions en attente",
      "sortBy": "Trier par",
      "task": "Tâche",
      "aiUncertainty": "Incertitude de l'IA",
      "confidence": "Confiance de l'IA :",
      "points": "Points :",
      "toGrading": "Aller à la correction",
      "confirmed": "Confirmé",
      "confirm": "Confirmer",
      "noClarificationNeeded": "Aucune clarification requise.",
      "worstAvg": "Moyenne la plus basse",
      "noDataYet": "Pas encore de données",
      "avgSuffix": "en moyenne",
      "frequentErrors": "Sources d'erreur fréquentes",
      "metricsPerTask": "Métriques par tâche",
      "gradeDistribution": "Répartition des notes",
      "count": "Nombre",
      "pdfReports": "Rapports PDF",
      "downloadingPdf": "Génération des rapports PDF...",
      "downloadPdf": "Télécharger les rapports PDF",
      "csvExport": "Export CSV des notes",
      "notConnected": "Pas encore connecté",
      "notMet": "Non atteint",
      "downloadingCsv": "Génération du CSV...",
      "downloadCsv": "Télécharger le CSV",
      "gradeScale": "Échelle de notation",
      "gradeFrom": "Note {{grade}} à partir de",
      "normalDistribution": "Distribution normale (Courbe de Gauss)",
      "activated": "Activé",
      "deactivated": "Désactivé",
      "curveStrength": "Force de la courbe",
      "curvingComingSoon": "L'ajustement de la courbe n'est pas encore disponible. Fonctionnalité à venir.",
      "noSubmissionsFound": "Aucune copie corrigée trouvée.",
      "avgPointsReached": "Ø Points obtenus",
      "pointsReached": "points obtenus",
      "gradeSystem": "Système de notation",
      "gradeBorders": "Limites de notes",
      "lowestGradeLabel": "Note la plus basse (à partir de 0%)",
      "tabs": {
        "students": "Aperçu des élèves",
        "clarification": "Clarification requise",
        "insights": "Aperçus des tâches",
        "grades": "Répartition des notes",
        "curving": "Barème & Ajustement",
        "export": "Export",
        "languageUse": "Maîtrise de la langue & Grammaire"
      },
      "gradingScales": {
        "german16": "Allemand (1–6)",
        "drittel": "Tiers (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "Points de note (0–15)",
        "numeric10": "10 points",
        "percentage": "Pourcentage",
        "custom": "Personnalisé"
      },
      "grammar": "Grammaire",
      "fehlerindex": "Indice d'erreurs (FI)",
      "grammarFiColumnHint": "N'inclut que les tâches encore notées via l'indice d'erreurs ; les tâches notées par règles ont leurs propres colonnes.",
      "taskLanguageUseColumn": "{{label}} · Maîtrise de la langue",
      "grammarTab": {
        "noGrammarTasks": "Cet examen ne contient aucune tâche avec évaluation grammaticale.",
        "fiTitle": "Déduction par indice d'erreurs",
        "fiDesc": "Indice d'erreurs = erreurs pour 100 mots. Le dépassement des seuils abaisse la note finale par paliers.",
        "fiUnsupportedScale": "Aucune déduction par palier n'est possible avec une échelle en pourcentage.",
        "fiAbove": "Si l'indice d'erreurs dépasse",
        "deductSteps": "déduire (paliers de note)",
        "matrixTitle": "Fautes de grammaire par élève et par tâche",
        "matrixDesc": "Nombre de fautes (indice d'erreurs entre parenthèses). Cliquer sur une cellule ouvre la correction en mode grammaire.",
        "fiSwitchTitle": "Appliquer l'indice d'erreurs pour cet examen",
        "fiSwitchDesc": "Utilise par défaut votre réglage de profil ; activez pour le remplacer uniquement pour cet examen.",
        "gradeWithFi": "Note (avec IE)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "Règles de maîtrise de la langue utilisées pour la notation",
        "ownRuleEntry": "{{label}} : règle propre ({{points}} pts)",
        "groupRuleEntry": "{{label}} ({{points}} pts)",
        "teacherRulesActive": "La maîtrise de la langue est évaluée directement lors de la correction selon vos règles personnelles. La déduction par indice d'erreurs est désactivée."
      }
    },
    "structureEditor": {
      "pointsInconsistent": "Les points ne correspondent pas. À chaque niveau, attribuez des points à toutes les tâches (dont la somme égale le total de la tâche parente) ou laissez-les toutes vides. Corrigez les tâches surlignées :",
      "pointsInconsistentTask": "Il manque des points à la tâche {{path}}",
      "totalPoints": "Points totaux (sous-tâches incluses)",
      "ownPoints": "Points propres (la réponse propre de cette tâche)",
      "tasksWithoutRegion": "Tâches sans zone marquée",
      "noPages": "Aucune page disponible.",
      "taskAreasDetected_one": "{{count}} zone de tâche détectée",
      "taskAreasDetected_other": "{{count}} zones de tâche détectées",
      "addArea": "Ajouter une zone",
      "remove": "Supprimer",
      "resetZoom": "Réinitialiser le zoom",
      "readOnly": "Lecture seule",
      "saving": "Enregistrement...",
      "saved": "Enregistré",
      "blankExamPage": "Page blanche de l'examen {{page}}",
      "deleteBbx": "Supprimer la zone",
      "retryOcr": "Relancer la reconnaissance de texte",
      "noTasksOnPage": "Aucune tâche sur cette page",
      "task": "Tâche",
      "noText": "Aucun texte",
      "imageContent": "Image (sans reconnaissance de texte) - la région d'image reconnue sera utilisée directement pour le traitement ultérieur",
      "additionalInfo": "Infos complémentaires",
      "noContent": "Aucun contenu",
      "linkedTasks": "Tâches liées",
      "noTasks": "Aucune tâche"
    },
    "demoSelector": {
      "title": "Sélectionner une démo",
      "description": "Choisissez un exemple d'examen. gradias simule le téléchargement et lance automatiquement l'extraction.",
      "examCount_one": "{{count}} examen",
      "examCount_other": "{{count}} examens",
      "studentCount_one": "{{count}} élève",
      "studentCount_other": "{{count}} élèves",
      "examLanguage": "Langue de l'examen",
      "subjects": {
        "math": "Mathématiques",
        "english": "Anglais",
        "technical": "École professionnelle",
        "biology": "Biologie",
        "spanish": "Espagnol",
        "french": "Français",
        "physics": "Physique",
        "political_education": "Éducation civique",
        "german": "Allemand"
      },
      "grades": {
        "gesamtschule": "Ecole intégrée",
        "highSchool": "Lycée",
        "elementarySchool": "École primaire",
        "vocationalSchool": "École professionnelle / Formation pour adultes",
        "middleSchool": "Collège",
        "university": "Université",
        "primarySchool": "École primaire"
      },
      "exams": {
        "kaarst": {
          "name": "Maths - analyse de courbe",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "arne": {
          "name": "Maths - fractions, 6e",
          "description": "Copies d'élèves"
        },
        "lynehamMath": {
          "name": "Mathématiques",
          "description": "Copies d'élèves"
        },
        "tuevBauleiter": {
          "name": "Conducteur de travaux",
          "description": "Copies d'élèves et solution type"
        },
        "tuvPhotovoltaik": {
          "name": "Photovoltaïque",
          "description": "Copies d'élèves et solution type"
        },
        "engVocabulary": {
          "name": "Test de vocabulaire (anglais)",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "bioImageLabeling": {
          "name": "Biologie - étiquetage d'images",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "mathProofFr": {
          "name": "Preuve mathématique",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "mathProofEng": {
          "name": "Preuve mathématique",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "dictationEs": {
          "name": "Dictée — Espagnol",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "dictationFr": {
          "name": "Dictée — Français",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "plotting": {
          "name": "Tracé de graphique",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "curveAnalysis": {
          "name": "Analyse de courbe",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "calculationDe": {
          "name": "Physique",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "calculationFr": {
          "name": "Calcul",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "calculationEs": {
          "name": "Calcul",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "calculationEn": {
          "name": "Calcul",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "multipleChoiceDe": {
          "name": "Choix multiple",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "multipleChoiceEn": {
          "name": "Choix multiple",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "multipleChoiceFr": {
          "name": "Choix multiple",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "multipleChoiceEs": {
          "name": "Choix multiple",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "politics12German": {
          "name": "Éducation civique — 12e année",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "poetry12German": {
          "name": "Analyse de poème — 12e année",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "poetry12English": {
          "name": "Analyse de poème — 12e année",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "poetry12French": {
          "name": "Analyse de poème — 12e année",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "materialBasedEnglish": {
          "name": "Essai à partir de documents",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        },
        "materialBasedGerman": {
          "name": "Essai à partir de documents",
          "description": "Dossier complet : copies d'élèves, solution type, barème de notation et sujet vierge"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "Enregistrement et recompilation…",
      "unsavedChanges": "Modifications non enregistrées",
      "allChangesSaved": "Toutes les modifications sont enregistrées",
      "readOnlyBanner": "Cet examen est en lecture seule : un corrigé type, un barème de notation ou des copies d'élèves existent déjà sur la structure des tâches, il n'est donc plus possible d'y apporter de modifications ici.",
      "generatingExam": "Génération de l'examen…",
      "refiningExam": "Mise à jour de l'examen…",
      "downloadPdf": "Télécharger le PDF",
      "preparingPdf": "Préparation du PDF…",
      "notSaved": "Non enregistré : {{message}}",
      "seeProblemsBelow": "voir les problèmes ci-dessous",
      "noExam": "Aucun examen.",
      "noSourceYet": "Cet examen n'a pas encore de source.",
      "noPreviewYet": "Pas encore d'aperçu compilé — cliquez sur un bloc ou un point pour modifier et en générer un.",
      "tellAiPlaceholder": "Indiquez à l'IA ce qu'il faut changer ...",
      "delete": "Supprimer",
      "applying": "Application en cours …",
      "send": "Envoyer",
      "done": "Terminé",
      "describeAiPlaceholder": "Décrivez à l'IA la tâche à ajouter ici ...",
      "add": "Ajouter",
      "adding": "Ajout en cours …",
      "task": "Tâche {{number}}",
      "taskNumber": "Numéro de tâche",
      "type": "Type",
      "points": "Points",
      "lines": "Lignes",
      "taskText": "Texte de la tâche",
      "material": "Matériel",
      "title": "Titre",
      "usedByTasks": "Utilisé par les tâches (numéros séparés par des virgules)",
      "text": "Texte",
      "multipleChoice": "Choix multiple",
      "removeOption": "Supprimer l'option",
      "addOption": "+ Ajouter une option",
      "figureProperties": "Propriétés de la figure",
      "caption": "Légende",
      "examSetup": "Configuration de l'examen",
      "subject": "Matière",
      "class": "Classe",
      "duration": "Durée",
      "totalPoints": "Total des points",
      "globalHints": "Indications / instructions générales",
      "studentView": "Remplir en ligne"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "Regroupe les sous-tâches, pas de réponse directe",
    "default": "Type général quand aucun autre ne convient",
    "shortText": "Réponse écrite courte (quelques phrases)",
    "essay": "Texte long et structuré, p.ex. dissertation",
    "diagram": "Dessin technique, p.ex. organigramme ou circuit",
    "sketch": "Croquis ou illustration libre",
    "gapText": "Texte à trous",
    "labelImage": "Légender les parties d'une image ou d'un diagramme",
    "multipleChoice": "Choisir parmi des options données",
    "imageAnalysis": "Décrire ou analyser une image fournie",
    "mapping": "Relier des objets ou alternatives correspondants",
    "legalCase": "Analyse juridique (Gutachtenstil)",
    "calculation": "Calculs mathématiques ou physiques",
    "mathematicalProof": "Preuve mathématique formelle",
    "curveAnalysis": "Étude de fonction (racines, extrema, …)",
    "plotting": "Tracer un graphique, une fonction ou des points dans un repère",
    "geometry": "Constructions géométriques ou calculs (dessin)",
    "programming": "Écrire ou analyser du code source",
    "art": "Créer une œuvre d'art ou un design artistique",
    "dictation": "Écrire un texte dicté",
    "translation": "Traduire un texte ou des mots dans une autre langue",
    "chemicalFormula": "Équations de réaction chimique ou formules",
    "music": "Lire ou écrire des partitions musicales",
    "literaryAnalysisPoetry": "Analyser un poème",
    "analysisNonFiction": "Analyser un texte non fictionnel",
    "materialBasedEssay": "Rédiger un essai à partir de documents fournis"
  },
  "TaskTypes": {
    "taskFrame": "Cadre de la tâche",
    "default": "Par défaut",
    "shortText": "Texte court",
    "essay": "Essai",
    "diagram": "Diagramme",
    "sketch": "Croquis",
    "gapText": "Texte à trous",
    "labelImage": "Légender l'image",
    "multipleChoice": "Choix multiple",
    "imageAnalysis": "Analyse d'image",
    "mapping": "Mise en correspondance",
    "legalCase": "Cas juridique",
    "calculation": "Calcul",
    "mathematicalProof": "Preuve mathématique",
    "curveAnalysis": "Analyse de courbe",
    "plotting": "Tracé de graphique",
    "geometry": "Géométrie",
    "programming": "Programmation",
    "art": "Art",
    "dictation": "Dictée",
    "translation": "Traduction",
    "chemicalFormula": "Formule chimique",
    "music": "Musique",
    "literaryAnalysisPoetry": "Analyse de poésie",
    "analysisNonFiction": "Analyse de texte non fictionnel",
    "materialBasedEssay": "Essai à partir de documents"
  },
  "GapText": {
    "gap": "Lacune",
    "correct": "Correct",
    "incorrect": "Incorrect",
    "empty": "Vide",
    "points": "Points",
    "expectedAnswer": "Réponse attendue",
    "studentAnswer": "Réponse de l'élève",
    "status": "Statut"
  },
  "progress": {
    "analyzingSplit": "Analyse de la séparation",
    "extractingAnswers": "Extraction des réponses des élèves...",
    "errorExtractingAnswers": "Erreur lors de l'extraction des réponses",
    "answersExtracted": "Réponses des élèves extraites",
    "extractingMasterSolution": "Extraction du contenu de la solution type",
    "errorStructureMasterSolution": "Erreur de création de la structure (solution type)",
    "errorExtractingMasterSolution": "Erreur lors de l'extraction de la solution type",
    "masterSolutionExtracted": "Solution type extraite",
    "extractingGradingScheme": "Extraction des critères de notation",
    "errorStructureGradingScheme": "Erreur de création de la structure (critères de notation)",
    "errorExtractingGradingScheme": "Erreur lors de l'extraction des critères de notation",
    "gradingSchemeExtracted": "Critères de notation extraits",
    "noUsableMasterSolution": "Aucun contenu de solution type utilisable détecté. Veuillez vérifier le fichier ou ajuster l'attribution.",
    "noUsableGradingScheme": "Aucun critère de notation utilisable détecté. Veuillez vérifier le fichier ou ajuster l'attribution.",
    "analyzingStructure": "Analyse de la structure de l'examen",
    "noSubmissions": "Aucune copie trouvée",
    "errorStructureAnalysis": "Erreur lors de l'analyse de la structure de l'examen",
    "noTasksInStructure": "Aucune tâche trouvée lors de l'analyse",
    "extractingTaskDescriptions": "Extraction des descriptions de tâches",
    "errorTaskDescriptions": "Erreur lors de l'extraction des descriptions",
    "taskDescriptionsExtracted": "Descriptions de tâches extraites",
    "taskStructureCreated": "Structure des tâches créée",
    "waitingForStructureConfirmation": "En attente de la confirmation de la structure par l'utilisateur",
    "structureConfirmed": "Structure de l'examen confirmée",
    "structureConfirmationTimeout": "Délai d'attente dépassé pour la confirmation de la structure",
    "errorWaitingStructureConfirmation": "Erreur lors de l'attente de confirmation de la structure",
    "errorProcessingStructureConfirmation": "Erreur de traitement de la confirmation de la structure",
    "errorCreatingTaskStructure": "Erreur lors de la création de la structure des tâches",
    "pipelineFailedPrematurely": "Le processus a échoué prématurément",
    "assignmentConfirmed": "Attribution confirmée",
    "gradingRunning": "Correction en cours...",
    "gradingTaskX": "Correction de la tâche {{taskNumber}} ...",
    "gradingCompleted": "Correction terminée",
    "gradingTaskXCompleted": "Correction de la tâche {{taskNumber}} terminée"
  },
  "upload": {
    "noExamId": "Aucun ID d'examen trouvé",
    "noFileSelected": "Aucun fichier sélectionné",
    "processingFailed": "Le fichier n'a pas pu être traité",
    "invalidFileType": "Type de fichier invalide. Veuillez sélectionner un fichier PNG ou PDF.",
    "uploadError": "Erreur lors du téléchargement du fichier",
    "studentName": "Élève {{index}}",
    "noExamIdForReupload": "Erreur : Aucun ID d'examen disponible pour un nouveau téléchargement.",
    "reuploadCancelled": "INFO SYSTÈME : Annulation du téléchargement traitée.",
    "reuploadCancelFailed": "INFO SYSTÈME : L'annulation du téléchargement n'a pas pu être totalement traitée.",
    "filesMissing": "BLOCAGE SYSTÈME : Les fichiers suivants n'ont pas été trouvés : {{files}}. Assurez-vous que les noms correspondent exactement.",
    "assignmentMismatch": "BLOCAGE SYSTÈME : Les attributions de fichiers suivantes ne correspondent pas à la dernière proposition. Veuillez appeler send_assignment_confirmation_message et confirmer avec l'utilisateur.\n{{lines}}",
    "reuploadStarted": "Le nouveau téléchargement du fichier a commencé en arrière-plan. {{extra}}",
    "splitStarted": "La séparation des copies des élèves a commencé.",
    "assignmentProposalSent": "Message contenant la proposition d'attribution envoyé.",
    "assignmentConfirmationMessage": "Je ne suis pas tout à fait sûr de l'attribution des fichiers, je vous laisse vérifier rapidement.\n\nVeuillez confirmer dans la zone de dépôt que la proposition est correcte, ou ajustez-la si besoin. Ensuite, je pourrai continuer immédiatement.",
    "assignmentProposalFallback": "Veuillez vérifier ma proposition d'attribution et confirmer le mappage des fichiers.",
    "categorySubmissions": "Copies des élèves",
    "categoryMasterSolution": "Solution type",
    "categoryGradingScheme": "Barème de notation",
    "categoryBlankExam": "Examen vierge",
    "lowConfidenceListFormat": "'{{file}}' (prévu comme {{category}})",
    "mismatchFormat": "- {{name}} : précédemment proposé comme \"{{proposed}}\", maintenant fourni comme \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "Élève inconnu",
    "studentNumber": "Élève {{number}}",
    "pageAssignmentError": "Toutes les pages n'ont pas été attribuées exactement une fois",
    "nonConsecutive": "Pages non consécutives attribuées pour {{names}} (Réordonné par l'agent)",
    "uncertainty": "Incertitude avec {{names}}",
    "outlierLongExtremeSingle": "La copie de {{names}} est extrêmement longue",
    "outlierLongExtremePlural": "Les copies de {{names}} sont extrêmement longues",
    "outlierShortExtremeSingle": "La copie de {{names}} est extrêmement courte",
    "outlierShortExtremePlural": "Les copies de {{names}} sont extrêmement courtes",
    "outlierLongSingle": "La copie de {{names}} est inhabituellement longue",
    "outlierLongPlural": "Les copies de {{names}} sont inhabituellement longues",
    "outlierShortSingle": "La copie de {{names}} est inhabituellement courte",
    "outlierShortPlural": "Les copies de {{names}} sont inhabituellement courtes",
    "missingStudentNameSingle": "Impossible d'extraire un nom pour {{missingCount}} sur {{totalCount}} élève",
    "missingStudentNamePlural": "Impossible d'extraire un nom pour {{missingCount}} sur {{totalCount}} élèves",
    "splitAgentFailure": "Erreur de l'agent de séparation{{suffix}}",
    "errorPrefix": "Erreur",
    "warningPrefix": "Avertissement",
    "parseErrorFallback": "Les données n’ont pas pu être traitées. Veuillez vérifier l’attribution dans le canvas.",
    "messageError": "J'ai trouvé {{count}} élèves avec {{range}} pages chacun, mais un problème est survenu lors de l'attribution automatique des pages :\n{{problem}}\n\nVeuillez vérifier l'attribution dans le canevas de mappage et la corriger manuellement si nécessaire. Une fois terminé, veuillez confirmer dans le chat ou via le bouton pour que nous puissions continuer.",
    "messageWarning": "J'ai trouvé {{count}} élèves avec {{range}} pages chacun, mais il y a les remarques suivantes :\n{{problem}}\n\nSi vous le souhaitez, vous pouvez vérifier les remarques dans le canevas de mappage. Sinon, confirmez simplement pour continuer.",
    "messageSuccess": "J'ai trouvé {{count}} élèves avec {{range}} pages chacun. L'attribution est sans ambiguïté. Un nom a pu être extrait pour tous les élèves. Veuillez confirmer pour que nous puissions continuer.",
    "confirmationRequested": "Confirmation de séparation demandée",
    "splitAgentFailed": "La séparation automatique des soumissions d'étudiants a échoué. Veuillez réessayer de télécharger le fichier plus tard."
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**À propos des points :** J'ai détecté des points pour certaines tâches. Si vous téléversez un barème comportant les points (ou l'avez déjà fait), les points en seront tirés ; vous pouvez alors ignorer les points dans le canevas. Ils ne sont pertinents que si votre barème ne les indique pas ou si vous souhaitez en faire générer un.\n\nRègles d'attribution : pour chaque tâche, attribuez des points à toutes les sous-tâches directes de sorte qu'ils totalisent le total de la tâche parente, ou à aucune. Si vous n'attribuez pas de points aux sous-tâches mais seulement un total, l'IA les répartira automatiquement lors de la génération du barème.",
    "textCutoff": "Texte de la tâche incomplet",
    "missingInformation": "Information manquante",
    "imageUnreadable": "Image illisible",
    "task": "Tâche",
    "mainTasks_one": "J'ai identifié {{mainCount}} tâche principale.",
    "mainTasks_other": "J'ai identifié {{mainCount}} tâches principales.",
    "mainAndSubTasks_one": "J'ai identifié {{mainCount}} tâches principales et {{subCount}} sous-tâche.",
    "mainAndSubTasks_other": "J'ai identifié {{mainCount}} tâches principales et {{subCount}} sous-tâches.",
    "intro": "### J'ai identifié la structure de tâches suivante :\n\n{{countText}}",
    "problemsIntro": "\n\nLes problèmes suivants sont survenus lors de la reconnaissance des tâches : {{warnings}}. Veuillez vérifier les incertitudes dans le canevas, les modifier si nécessaire, puis confirmer via le bouton ou dans le chat.",
    "uncertaintyIntro": "\n\nIl y a des incertitudes concernant {{labels}}. Veuillez vérifier les incertitudes dans le canevas, les modifier si nécessaire, puis confirmer via le bouton ou dans le chat.",
    "success": "\n\nAucun problème n'est survenu lors de la reconnaissance des tâches. Si vous le souhaitez, vous pouvez quand même les vérifier dans le canevas, sinon veuillez confirmer via le bouton ou dans le chat."
  },
  "chatMessages": {
    "emptyState": "Commencez une conversation en tapant un message ci-dessous",
    "newMessage": "Nouveau message",
    "cancel": "Annuler",
    "send": "Envoyer",
    "edit": "Modifier",
    "editInCanvas": "Modifier dans le Canvas",
    "confirmed": "Confirmé",
    "confirm": "Confirmer",
    "confirmAssignment": "Confirmer l'attribution",
    "giveFeedback": "Donner un avis",
    "feedbackTitle": "Donner un avis",
    "feedbackDescription": "Dites-nous comment nous pouvons améliorer cette réponse.",
    "feedbackPlaceholder": "Votre avis ici...",
    "feedbackSubmit": "Soumettre l'avis",
    "submitAssignmentConfirmation": "Je confirme la répartition des pages et l’attribution aux élèves. Veuillez poursuivre.",
    "submitStructureConfirmation": "Je confirme la structure des tâches de l’examen.",
    "studentSubmissions": "Copies des élèves",
    "masterSolution": "Solution type",
    "gradingScheme": "Barème de notation",
    "blankExam": "Examen vierge",
    "confirmedAssignmentIntro": "L'attribution des fichiers confirmée :",
    "assignmentIntro": "J'ai attribué les fichiers comme suit. Veuillez vérifier et confirmer l'attribution :"
  },
  "AuthModal": {
    "loginError": "E-mail ou mot de passe incorrect.",
    "signupFailed": "L'inscription a échoué. Veuillez réessayer.",
    "passwordMismatch": "Les mots de passe ne correspondent pas.",
    "forgotPasswordProblem": "Un problème est survenu. Veuillez réessayer plus tard.",
    "waitlistTitle": "Vous êtes sur la liste !",
    "waitlistDesc": "Nous vous contacterons dès que la prochaine phase commencera.",
    "waitlistInactive": "Liste d'attente actuellement désactivée.",
    "backToLogin": "Retour à la connexion",
    "linkSentTitle": "Lien envoyé !",
    "linkSentDesc": "Compris",
    "forgotPasswordTitle": "Mot de passe oublié ?",
    "requestLink": "Demander un lien",
    "welcomeBack": "Bon retour",
    "createAccount": "Créer un compte",
    "emailLabel": "E-mail",
    "passwordLabel": "Mot de passe",
    "forgotPasswordLink": "Mot de passe oublié ?",
    "loginButton": "Se connecter",
    "firstNameLabel": "Prénom",
    "lastNameLabel": "Nom de famille",
    "schoolLabel": "École",
    "subjectsLabel": "Matières",
    "confirmPasswordLabel": "Confirmer",
    "signupButton": "S'inscrire",
    "registerHere": "S'inscrire ici",
    "loginHere": "Se connecter ici",
    "continueGuest": "Continuer sans s'inscrire →"
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "L'image \"{{name}}\" est trop grande (max. 5 Mo).",
      "previewError": "L'aperçu n'a pas pu être généré pour {{name}}.",
      "submitError": "Un problème est survenu. Veuillez réessayer."
    },
    "success": {
      "title": "Merci pour votre retour !",
      "description": "Nous avons bien reçu votre message. Votre contribution nous aide énormément à améliorer Gradias chaque jour un peu plus.",
      "backButton": "Retour à l'examen"
    },
    "header": {
      "title": "Faire un retour"
    },
    "content": {
      "description": "Vous avez remarqué un bug, vous avez une idée de génie ou vous voulez simplement nous dire quelque chose ? Nous lisons chaque message !"
    },
    "categories": {
      "title": "De quoi s'agit-il ?",
      "bug": {
        "title": "Erreur / Bug",
        "desc": "Quelque chose ne fonctionne pas"
      },
      "feature": {
        "title": "Idée / Demande",
        "desc": "Une nouvelle fonctionnalité"
      },
      "general": {
        "title": "Autre",
        "desc": "Retours généraux"
      }
    },
    "message": {
      "title": "Votre message",
      "placeholder": "Décrivez votre demande de manière aussi détaillée que possible..."
    },
    "upload": {
      "title": "Joindre une capture d'écran (Facultatif)",
      "clickToSelect": "Cliquez pour sélectionner des images",
      "formatConstraint": "PNG, JPG jusqu'à 5 Mo max. par image",
      "attachedImages": "Images jointes",
      "removeImage": "Supprimer l'image"
    },
    "submit": {
      "sending": "Envoi en cours...",
      "send": "Envoyer le retour"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "La répartition des élèves a été confirmée avec succès. L’extraction de la structure des tâches peut maintenant continuer. Remercie l’utilisateur d’avoir confirmé la répartition et indique-lui que l’extraction commence maintenant.",
      "pending": "La répartition des élèves est toujours en attente de confirmation."
    },
    "structure": {
      "masterAndGrading": "La structure des tâches a été confirmée avec succès. L’extraction se poursuit maintenant en arrière-plan. Une solution modèle et un barème ont déjà été téléversés et seront traités en arrière-plan. Remercie brièvement l’utilisateur pour la confirmation de la structure et indique-lui que l’extraction se poursuit. Propose de lancer la correction.",
      "masterOnly": "La structure des tâches a été confirmée avec succès. L’extraction se poursuit maintenant en arrière-plan. Une solution modèle a déjà été téléversée, mais il manque encore le barème. Remercie brièvement l’utilisateur pour la confirmation de la structure et indique-lui que l’extraction se poursuit. Propose de générer ensuite un barème basé sur l’IA.",
      "gradingOnly": "La structure des tâches a été confirmée avec succès. L’extraction se poursuit maintenant en arrière-plan. Un barème a déjà été téléversé, mais il manque encore la solution modèle. Remercie brièvement l’utilisateur pour la confirmation de la structure et indique-lui que l’extraction se poursuit. Propose de générer ensuite une solution modèle basée sur l’IA.",
      "none": "La structure des tâches a été confirmée avec succès. L’extraction se poursuit maintenant en arrière-plan. Il manque encore la solution modèle. Remercie brièvement l’utilisateur pour la confirmation de la structure, indique-lui que l’extraction se poursuit et demande-lui s’il souhaite que tu génères une solution modèle basée sur l’IA une fois l’extraction terminée ou s’il préfère en téléverser une via le trombone du champ de chat."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "Erreur : aucun message de confirmation de séparation attribué n’a été trouvé.",
      "missingStructureMessage": "Erreur : aucun message de confirmation de structure attribué n’a été trouvé.",
      "structureContentMissing": "Erreur : le message de confirmation de structure n’a pas pu être chargé.",
      "splitFailure": "Erreur lors de la confirmation de la séparation.",
      "structureFailure": "Erreur lors de la confirmation de la structure."
    }
  },
  "toolFallbackDesc": {
    "default": "Executer etape outil",
    "set_metadata": "Définir les métadonnées",
    "create_exam": "Créer le devoir maintenant",
    "generate_master_solution": "Generer correction modele",
    "refine_master_solution": "Affiner correction modele",
    "generate_grading_scheme": "Generer bareme evaluation",
    "refine_grading_scheme": "Affiner bareme evaluation",
    "run_grading_agent": "Lancer agent notation",
    "set_task_score": "Definir la note manuellement",
    "open_canvas": "Ouvrir vue canvas",
    "update_open_task_content": "Mettre a jour tache",
    "send_assignment_confirmation_message": "Demander confirmation attribution",
    "process_files": "Traiter les fichiers televerses",
    "confirm_split_in_chat": "Confirmer separation chat",
    "confirm_structure_in_chat": "Confirmer structure chat",
    "query_exams": "Consulter examens",
    "query_submissions": "Consulter copies",
    "get_available_options": "Obtenir options disponibles",
    "get_task_types": "Obtenir les types de tâches",
    "download_ms_gs": "Télécharger le corrigé et le barème",
    "download_summary_reports": "Télécharger les rapports de synthèse",
    "save_teacher_memory": "Mémoriser la préférence",
    "get_teacher_memory": "Consulter les préférences",
    "delete_teacher_memory": "Supprimer les préférences",
    "reprocess_errored_submissions": "Retraiter les copies en erreur"
  },
  "Subjects": {
    "math": "Mathématiques",
    "physics": "Physique",
    "chemistry": "Chimie",
    "biology": "Biologie",
    "history": "Histoire",
    "geography": "Géographie",
    "english": "Anglais",
    "german": "Allemand",
    "french": "Français",
    "spanish": "Espagnol",
    "computer_science": "Informatique",
    "social_studies": "Sciences Sociales",
    "other": "Autre"
  },
  "ExamNotifications": {
    "newMessage": "Nouveau Message"
  },
  "LanguageUseTemplates": {
    "essay": "Niveaux de compétence · Performance de présentation\n\n* excellent :\n  - Le texte est structuré de manière claire et logique, avec des liaisons efficaces entre les parties.\n  - Le langage spécialisé est employé avec assurance et précision.\n  - Les citations sont intégrées correctement et introduites en contexte ; les références incluent le numéro de ligne.\n  - La syntaxe est variée, stylistiquement assurée et adaptée à l'objet littéraire.\n  - La grammaire, l'orthographe et la ponctuation sont presque sans faute.\n* bien :\n  - Le texte est structuré de façon cohérente.\n  - Le langage spécialisé est employé pour la plupart avec assurance.\n  - Les citations sont utilisées de manière appropriée et correctement référencées.\n  - La syntaxe est correcte et variée.\n  - Peu d'infractions à la grammaire, à l'orthographe et à la ponctuation.\n* satisfaisant :\n  - La structure est perceptible, mais pas cohérente de façon continue.\n  - Le langage spécialisé est employé de manière fonctionnelle, mais pas toujours précise.\n  - Des citations sont utilisées, les références sont pour la plupart correctes.\n  - La syntaxe est pour la plupart correcte, parfois monotone.\n  - Les infractions à la grammaire, à l'orthographe et à la ponctuation ne nuisent pas à la compréhension.\n* suffisant :\n  - La structure n'est perceptible que de façon rudimentaire.\n  - Le langage spécialisé n'est employé que partiellement ou de façon imprécise.\n  - Les citations sont incohérentes ou incomplètement référencées.\n  - La syntaxe est monotone, avec de fréquentes incertitudes.\n  - La correction linguistique est limitée ; la compréhension est parfois entravée.\n* insuffisant :\n  - La présentation est largement non structurée.\n  - Le langage spécialisé est largement absent ou employé de façon incorrecte.\n  - Les citations sont absentes ou incorrectes.\n  - Les lacunes linguistiques nuisent nettement à la compréhension.\n* très insuffisant :\n  - La présentation est si déficiente que le travail est à peine compréhensible.\n  - Les exigences de base d'une dissertation d'interprétation littéraire écrite ne sont pas perceptibles.",
    "analysisNonFiction": "Niveaux de compétence · Performance de présentation\n\n* excellent :\n  - Le texte est structuré de manière claire et logique, avec des liaisons efficaces entre les parties.\n  - Le langage spécialisé est employé avec assurance et précision.\n  - Les citations sont intégrées correctement et introduites en contexte ; les références incluent le numéro de ligne.\n  - La syntaxe est variée, stylistiquement assurée et adaptée à l'objet littéraire.\n  - La grammaire, l'orthographe et la ponctuation sont presque sans faute.\n* bien :\n  - Le texte est structuré de façon cohérente.\n  - Le langage spécialisé est employé pour la plupart avec assurance.\n  - Les citations sont utilisées de manière appropriée et correctement référencées.\n  - La syntaxe est correcte et variée.\n  - Peu d'infractions à la grammaire, à l'orthographe et à la ponctuation.\n* satisfaisant :\n  - La structure est perceptible, mais pas cohérente de façon continue.\n  - Le langage spécialisé est employé de manière fonctionnelle, mais pas toujours précise.\n  - Des citations sont utilisées, les références sont pour la plupart correctes.\n  - La syntaxe est pour la plupart correcte, parfois monotone.\n  - Les infractions à la grammaire, à l'orthographe et à la ponctuation ne nuisent pas à la compréhension.\n* suffisant :\n  - La structure n'est perceptible que de façon rudimentaire.\n  - Le langage spécialisé n'est employé que partiellement ou de façon imprécise.\n  - Les citations sont incohérentes ou incomplètement référencées.\n  - La syntaxe est monotone, avec de fréquentes incertitudes.\n  - La correction linguistique est limitée ; la compréhension est parfois entravée.\n* insuffisant :\n  - La présentation est largement non structurée.\n  - Le langage spécialisé est largement absent ou employé de façon incorrecte.\n  - Les citations sont absentes ou incorrectes.\n  - Les lacunes linguistiques nuisent nettement à la compréhension.\n* très insuffisant :\n  - La présentation est si déficiente que le travail est à peine compréhensible.\n  - Les exigences de base d'une dissertation d'interprétation littéraire écrite ne sont pas perceptibles.",
    "genericGroup": "Niveaux de compétence · Performance de présentation\n\n* excellent :\n  - Le texte est structuré de manière claire et logique, avec des liaisons efficaces entre les parties.\n  - Le langage spécialisé est employé avec assurance et précision.\n  - Les citations sont intégrées correctement et introduites en contexte ; les références incluent le numéro de ligne.\n  - La syntaxe est variée, stylistiquement assurée et adaptée à l'objet littéraire.\n  - La grammaire, l'orthographe et la ponctuation sont presque sans faute.\n* bien :\n  - Le texte est structuré de façon cohérente.\n  - Le langage spécialisé est employé pour la plupart avec assurance.\n  - Les citations sont utilisées de manière appropriée et correctement référencées.\n  - La syntaxe est correcte et variée.\n  - Peu d'infractions à la grammaire, à l'orthographe et à la ponctuation.\n* satisfaisant :\n  - La structure est perceptible, mais pas cohérente de façon continue.\n  - Le langage spécialisé est employé de manière fonctionnelle, mais pas toujours précise.\n  - Des citations sont utilisées, les références sont pour la plupart correctes.\n  - La syntaxe est pour la plupart correcte, parfois monotone.\n  - Les infractions à la grammaire, à l'orthographe et à la ponctuation ne nuisent pas à la compréhension.\n* suffisant :\n  - La structure n'est perceptible que de façon rudimentaire.\n  - Le langage spécialisé n'est employé que partiellement ou de façon imprécise.\n  - Les citations sont incohérentes ou incomplètement référencées.\n  - La syntaxe est monotone, avec de fréquentes incertitudes.\n  - La correction linguistique est limitée ; la compréhension est parfois entravée.\n* insuffisant :\n  - La présentation est largement non structurée.\n  - Le langage spécialisé est largement absent ou employé de façon incorrecte.\n  - Les citations sont absentes ou incorrectes.\n  - Les lacunes linguistiques nuisent nettement à la compréhension.\n* très insuffisant :\n  - La présentation est si déficiente que le travail est à peine compréhensible.\n  - Les exigences de base d'une dissertation d'interprétation littéraire écrite ne sont pas perceptibles.",
    "materialBasedEssay": "Écriture à partir de documents (rédaction de textes argumentatifs / informatifs)\n\nPerformance de contenu et utilisation des documents (compréhension / structure du texte) :\n* L'introduction est concise, éveille l'intérêt du lecteur et amène le sujet (les transitions toutes faites sont évitées).\n* Une structure cohérente est perceptible, correspondant à tous les éléments du type de texte demandé (par ex. commentaire, essai, article).\n* Le sujet et la problématique qui lui est associée sont clairement délimités au début.\n* Les notions de base importantes sont expliquées de manière appropriée si nécessaire.\n* Tous les documents fournis sont pris en compte et intégrés au texte de façon pertinente et exacte sur le fond.\n* La transparence est assurée pour les propos rapportés (citation correcte, paraphrase et référence aux sources).\n* Une distinction claire est établie entre l'exposé des faits, l'argumentation et l'appréciation personnelle.\n* L'argumentation est large et nuancée (elle prend en compte divers aspects du sujet ainsi que d'éventuels contre-arguments).\n* Les arguments individuels sont convaincants pour le public visé, clairement structurés, expliqués et étayés par des preuves/exemples.\n* Outre les arguments tirés des documents, des arguments personnels et des connaissances spécialisées propres sont apportés.\n* L'argumentation est réunie à la fin dans une conclusion, éventuellement suivie d'une perspective d'avenir.\n\nPerformance linguistique et mise en forme du texte (performance de présentation) :\n* La forme linguistique correspond au type de texte demandé, avec un langage clair, précis et des formulations personnelles.\n* Le vocabulaire, la maîtrise des termes spécialisés et le style fonctionnel sont précis, nuancés et stylistiquement appropriés.\n* La construction des phrases est maîtrisable, variée et grammaticalement complexe.\n* Les fautes normatives (de grammaire, d'orthographe et de ponctuation) ne nuisent pas à la fluidité de la lecture.",
    "literaryAnalysisPoetry": "Performance de présentation\n* 1. Le candidat structure son texte de manière cohérente, logique, rigoureuse et avec clarté de pensée :\n  - pondération appropriée des sous-tâches dans la réalisation\n  - organisation structurée et pondérée de manière appropriée du travail\n  - enchaînement cohérent des différentes étapes de travail\n  - enchaînement logique cohérent entre les phrases\n* 2. Le candidat formule ses propos en respectant les exigences de la langue spécialisée et de la méthodologie disciplinaire :\n  - séparation entre le niveau de l'action et le métaniveau\n  - mise en relation justifiée des affirmations descriptives, interprétatives et évaluatives\n  - utilisation de la terminologie spécialisée dans un contexte pertinent\n  - respect des temps verbaux\n  - restitution correcte du discours rapporté (modalité)\n* 3. Le candidat étaye ses affirmations par des citations appropriées et correctes :\n  - usage judicieux de citations complètes ou abrégées à visée argumentative\n* 4. Le candidat s'exprime avec précision linguistique générale, assurance stylistique et différenciation conceptuelle :\n  - un style d'écriture objectif et distancié\n  - un registre propre à la langue écrite\n  - une capacité d'expression conceptuelle abstraite\n* 5. Le candidat formule avec assurance lexicale et syntaxique, de façon variée et complexe (tout en restant clair).\n* 6. Le candidat écrit avec correction linguistique."
  },
  "LatexEditor": {
    "insertFormula": "Formule",
    "insertFormulaHint": "Insérer une nouvelle formule à la position du curseur",
    "switchToRawLatex": "Passer au LaTeX brut",
    "switchToVisualEditor": "Passer à l'éditeur visuel",
    "naturalLanguageHint": "Décrivez cette formule en langage naturel",
    "naturalLanguagePlaceholder": "p. ex. « intégrale de 0 à 10 de x² »",
    "naturalLanguageError": "Échec de la traduction. Veuillez réessayer.",
    "insert": "Insérer",
    "removeFormula": "Supprimer la formule",
    "cancel": "Annuler"
  },
  "StudentExam": {
    "loading": "Chargement de l’examen…",
    "examFallbackTitle": "Examen",
    "classLabel": "Classe {{class}}",
    "namePlaceholder": "Ton nom",
    "answeredCount": "{{answered}} / {{total}} traitées",
    "submit": "Rendre",
    "signInRequiredTitle": "Connexion requise",
    "signInRequiredBody": "Connecte-toi pour traiter cet examen.",
    "signInAction": "Se connecter",
    "unavailableTitle": "Indisponible",
    "submittedTitle": "Rendu",
    "submittedBody": "Tes réponses ont été enregistrées et sont prêtes pour la correction.",
    "errors": {
      "loadFailed": "L’examen n’a pas pu être chargé.",
      "notFound": "Cet examen n’existe pas.",
      "notSignedIn": "Non connecté.",
      "noAccess": "Examen introuvable ou accès refusé.",
      "noTasks": "Cet examen ne contient pas encore d’exercices.",
      "uploadedExam": "Cet examen a été importé et non créé : il ne peut pas être rempli en ligne.",
      "studentsOnly": "Le remplissage en ligne n'est disponible que pour les comptes élèves.",
      "renderFailed": "L’examen n’a pas pu être affiché.",
      "unreadableAnswers": "Les réponses n’ont pas pu être lues.",
      "submitFailed": "Échec de l’envoi."
    },
    "canvas": {
      "undo": "Annuler",
      "clear": "Effacer",
      "pen": "Stylo",
      "eraser": "Gomme",
      "redo": "Rétablir",
      "zoom": "Dessiner en grand",
      "zoomClose": "Fermer la vue agrandie",
      "penWidth": "Épaisseur {{width}}"
    }
  }
}
